import { render, staticRenderFns } from "./FilmAccordion.vue?vue&type=template&id=41b6ef7d&scoped=true&"
import script from "./FilmAccordion.vue?vue&type=script&lang=js&"
export * from "./FilmAccordion.vue?vue&type=script&lang=js&"
import style0 from "./FilmAccordion.vue?vue&type=style&index=0&id=41b6ef7d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b6ef7d",
  null
  
)

export default component.exports